<template>
    <div class="body_main">
        <div class="count_body_bd">
            <!-- 今日预约统计面板 -->
            <div class="today_panel">
                <!-- 左侧：日期标题区 -->
                <div class="today_panel_left">
                    <div class="today_panel_icon">
                        <el-icon size="28"><Calendar /></el-icon>
                    </div>
                    <div class="today_panel_title">
                        <div class="today_main_title">今日预约</div>
                        <div class="today_sub_title">{{ todayLabel }}</div>
                    </div>
                    <div class="today_divider"></div>
                    <div class="today_total_block">
                        <span class="today_total_num">{{ statData.total }}</span>
                        <span class="today_total_label">总预约数</span>
                    </div>
                </div>

                <!-- 右侧：统计卡片区 -->
                <div class="today_panel_right">
                    <div class="stat_card stat_card_wait_sign">
                        <div class="stat_card_icon">
                            <el-icon size="20"><Clock /></el-icon>
                        </div>
                        <div class="stat_card_info">
                            <span class="stat_num">{{ statData.waitSign }}</span>
                            <span class="stat_label">待签到</span>
                        </div>
                    </div>
                    <div class="stat_card stat_card_wait_visit">
                        <div class="stat_card_icon">
                            <el-icon size="20"><UserFilled /></el-icon>
                        </div>
                        <div class="stat_card_info">
                            <span class="stat_num">{{ statData.waitVisit }}</span>
                            <span class="stat_label">待就诊</span>
                        </div>
                    </div>
                    <div class="stat_card stat_card_visiting">
                        <div class="stat_card_icon">
                            <el-icon size="20"><FirstAidKit /></el-icon>
                        </div>
                        <div class="stat_card_info">
                            <span class="stat_num">{{ statData.visiting }}</span>
                            <span class="stat_label">就诊中</span>
                        </div>
                    </div>
                    <div class="stat_card stat_card_done">
                        <div class="stat_card_icon">
                            <el-icon size="20"><CircleCheck /></el-icon>
                        </div>
                        <div class="stat_card_info">
                            <span class="stat_num">{{ statData.done }}</span>
                            <span class="stat_label">已完成</span>
                        </div>
                    </div>
                    <div class="stat_card stat_card_cancel">
                        <div class="stat_card_icon">
                            <el-icon size="20"><CircleClose /></el-icon>
                        </div>
                        <div class="stat_card_info">
                            <span class="stat_num">{{ statData.cancel }}</span>
                            <span class="stat_label">已取消/失效</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="table_body_bd">
            <!-- 搜索 -->
            <el-form class="search_con" :model="queryParams" ref="queryForm" :inline="true" label-width="68px">
                <el-form-item label="预约人">
                    <el-input
                        v-model="queryParams.cardPatientName"
                        placeholder="预约人（模糊搜索）"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input
                        v-model="queryParams.cardPatientPhone"
                        placeholder="手机号（模糊搜索）"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="预约单号">
                    <el-input
                        v-model="queryParams.reSerialNo"
                        placeholder="预约单号（模糊搜索）"
                        clearable
                    />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="Search" @click="getTodayReservationListInfo">搜索</el-button>
                    <el-button icon="Refresh" @click="resetQuery">重置</el-button>
                </el-form-item>
            </el-form>

            <!-- 表格 -->
            <div class="table_bd">
                <el-table
                    ref="multipleTable"
                    v-loading="tableLoading"
                    :data="tableData"
                    :max-height="tableHeight"
                    style="width: 100%">
                    <template #empty>
                        <el-empty :image-size="120"></el-empty>
                    </template>
                    <el-table-column type="index" label="序号" width="50"> </el-table-column>
                    <el-table-column
                        prop="reSerialNo"
                        label="预约单号">
                    </el-table-column>
                    <el-table-column
                        label="预约人">
                        <template #default="scope">
                            <div class="base_con">
                                <el-image class="elImage" :src="scope.row.avatar"></el-image>
                                <div class="base_info">
                                    <span style="font-size: 16px; font-weight: 600; line-height: 24px">{{ scope.row.cardPatientName }}</span>
                                    <span style="font-size: 14px; color:#aaa; line-height: 24px">{{ scope.row.sexText }}  {{ scope.row.age }}岁</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约人手机号">
                        <template #default="scope">
                            <span>{{ scope.row.cardPatientPhone === null ? '---' : scope.row.cardPatientPhone }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约时间"
                        width="260">
                        <template #default="scope">
                            <span style="font-size: 14px; font-weight: 600">{{ scope.row.reTime === null ? '---' : scope.row.reTime }} {{scope.row.reTimeTypeText}}{{scope.row.reNo}}号</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约单类型"
                        width="120">
                        <template #default="scope">
                            <el-tag :type="scope.row.visitType === null || scope.row.visitType === '初诊'?'success':'warning'" disable-transitions>
                                {{ scope.row.visitType === null ? '初诊' : scope.row.visitType }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约单状态"
                        width="120">
                        <template #default="scope">
                            <el-tag
                                :type="scope.row.reStatus === '5' ? 'success' : scope.row.reStatus === '6' ? '' :
                                scope.row.reStatus === '7' ? 'danger' : scope.row.reStatus === '8' ? 'warning' :
                                scope.row.reStatus === '4' ? 'info' : scope.row.reStatus === '3' ? 'danger' :
                                scope.row.reStatus === '1' ? 'danger' : ''"
                                disable-transitions>{{ scope.row.reStatusText }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约医生">
                        <template #default="scope">
                            <span>{{ scope.row.doctorName === null ? '---' : scope.row.doctorName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="门诊科室">
                        <template #default="scope">
                            <span>{{ scope.row.odName === null ? '---' : scope.row.odName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="createTime"
                        label="创建时间">
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        label="操作"
                        width="120">
                        <template #default="scope">
                            <el-button type="warning" size="small" @click="handleSign(scope.row)" v-if="scope.row.reStatus === '8'">签到</el-button>
                            <span v-else>—</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页 -->
            <div class="table_pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-size="pageNums"
                    layout="prev, pager, next, total, sizes"
                    :total="totalCount">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import todayreservation from "@/assets/scripts/todayreservation/index";

export default todayreservation;
</script>

<style scoped>
/* ===== 今日预约统计面板 ===== */
.today_panel {
    display: flex;
    align-items: stretch;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(64, 128, 255, 0.10);
    margin-bottom: 16px;
    overflow: hidden;
    border: 1px solid #e8efff;
    min-height: 96px;
}

/* 左侧标题区 */
.today_panel_left {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 20px 28px;
    background: linear-gradient(135deg, #4080ff 0%, #73a7ff 100%);
    min-width: 320px;
    flex-shrink: 0;
}

.today_panel_icon {
    width: 52px;
    height: 52px;
    background: rgba(255, 255, 255, 0.22);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    flex-shrink: 0;
}

.today_panel_title {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.today_main_title {
    font-size: 20px;
    font-weight: 700;
    color: #fff;
    line-height: 1.2;
    letter-spacing: 1px;
}

.today_sub_title {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.82);
}

.today_divider {
    width: 1px;
    height: 40px;
    background: rgba(255, 255, 255, 0.30);
    flex-shrink: 0;
    margin: 0 4px;
}

.today_total_block {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
}

.today_total_num {
    font-size: 32px;
    font-weight: 800;
    color: #fff;
    line-height: 1;
}

.today_total_label {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.80);
    letter-spacing: 1px;
}

/* 右侧统计卡片区 */
.today_panel_right {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 24px;
    background: #f7faff;
}

.stat_card {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    border-radius: 10px;
    background: #fff;
    border: 1.5px solid transparent;
    box-shadow: 0 1px 4px rgba(0,0,0,0.06);
    transition: box-shadow 0.2s, transform 0.2s;
    cursor: default;
    min-width: 0;
}

.stat_card:hover {
    box-shadow: 0 4px 14px rgba(0,0,0,0.10);
    transform: translateY(-2px);
}

.stat_card_icon {
    width: 38px;
    height: 38px;
    border-radius: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.stat_card_info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
}

.stat_num {
    font-size: 22px;
    font-weight: 700;
    line-height: 1;
}

.stat_label {
    font-size: 11px;
    color: #999;
    white-space: nowrap;
    letter-spacing: 0.5px;
}

/* 各状态卡片色调 */
.stat_card_wait_sign {
    border-color: #fff3e6;
}
.stat_card_wait_sign .stat_card_icon {
    background: #fff3e6;
    color: #f07800;
}
.stat_card_wait_sign .stat_num {
    color: #f07800;
}

.stat_card_wait_visit {
    border-color: #e6f4ff;
}
.stat_card_wait_visit .stat_card_icon {
    background: #e6f4ff;
    color: #1677ff;
}
.stat_card_wait_visit .stat_num {
    color: #1677ff;
}

.stat_card_visiting {
    border-color: #e6fff0;
}
.stat_card_visiting .stat_card_icon {
    background: #e6fff0;
    color: #00b96b;
}
.stat_card_visiting .stat_num {
    color: #00b96b;
}

.stat_card_done {
    border-color: #f0f5ff;
}
.stat_card_done .stat_card_icon {
    background: #f0f5ff;
    color: #4080ff;
}
.stat_card_done .stat_num {
    color: #4080ff;
}

.stat_card_cancel {
    border-color: #fff1f0;
}
.stat_card_cancel .stat_card_icon {
    background: #fff1f0;
    color: #cf1322;
}
.stat_card_cancel .stat_num {
    color: #cf1322;
}
</style>
